<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="my-html-cover">
</a>
<a href="https://earlybirdbooks.com/freebook?q=58e70e84e1799d0f58a9f167" target="_blank">
<img alt="image" src="Advert/Front-add.jpg" style="height:100%; text-align:center;"/>
</a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front-add.vue?18f14ff7